import { Instance, SnapshotOut, types } from "mobx-state-tree"
import _ from "lodash";
import {
  CycleActual,
  CycleDisease,
  CyclePrediction,
  CycleToDo,
  Fasting,
  Feed,
  FeedingTrayControl,
  File,
  Harvest,
  Measurement,
  Mortality,
  MultiMeasurement,
  Parameter,
  Sampling,
  Treatment,
} from "../../../../../database"
import { Platform } from "react-native";
import { Toast } from "native-base";
import moment from "moment";

const CycleStoreProps = {
  cycleId: types.maybeNull(types.number),
  cycle: types.maybeNull(types.frozen()),
  multiMeasurementId: types.maybeNull(types.number),
  multiMeasurements: types.optional(types.array(types.frozen()), []),
  waterQualityMultiMeasurementId: types.maybeNull(types.number),
  waterQualityMultiMeasurements: types.optional(types.array(types.frozen()), []),
  feedId: types.maybeNull(types.number),
  feeds: types.optional(types.array(types.frozen()), []),
  fastingId: types.maybeNull(types.number),
  fastings: types.optional(types.array(types.frozen()), []),
  feedingTrayControlId: types.maybeNull(types.number),
  feedingTrayControls: types.optional(types.array(types.frozen()), []),
  samplingId: types.maybeNull(types.number),
  samplings: types.optional(types.array(types.frozen()), []),
  treatmentId: types.maybeNull(types.number),
  treatments: types.optional(types.array(types.frozen()), []),
  harvestId: types.maybeNull(types.number),
  harvests: types.optional(types.array(types.frozen()), []),
  mortalityId: types.maybeNull(types.number),
  mortalities: types.optional(types.array(types.frozen()), []),
  chemicalMultiMeasurementId: types.maybeNull(types.number),
  chemicalMultiMeasurements: types.optional(types.array(types.frozen()), []),
  planktonMultiMeasurementId: types.maybeNull(types.number),
  planktonMultiMeasurements: types.optional(types.array(types.frozen()), []),
  microbiologyMultiMeasurementId: types.maybeNull(types.number),
  microbiologyMultiMeasurements: types.optional(types.array(types.frozen()), []),
  cycleDiseaseId: types.maybeNull(types.number),
  cycleDiseases: types.optional(types.array(types.frozen()), []),
  cyclePredictionId: types.maybeNull(types.number),
  cyclePredictions: types.optional(types.array(types.frozen()), []),
  cycleActualId: types.maybeNull(types.number),
  cycleActuals: types.optional(types.array(types.frozen()), []),
  cycleToDoId: types.maybeNull(types.number),
  cycleToDos: types.optional(types.array(types.frozen()), []),

  initiating: types.maybeNull(types.boolean),
  syncingLabel: types.maybeNull(types.string),

  queryingMultiMeasurement: types.maybeNull(types.boolean),
  syncingMultiMeasurement: types.maybeNull(types.boolean),
  syncedMultiMeasurement: types.maybeNull(types.boolean),
  queryingWaterQualityMultiMeasurement: types.maybeNull(types.boolean),
  syncingWaterQualityMultiMeasurement: types.maybeNull(types.boolean),
  syncedWaterQualityMultiMeasurement: types.maybeNull(types.boolean),
  queryingFeed: types.maybeNull(types.boolean),
  syncingFeed: types.maybeNull(types.boolean),
  syncedFeed: types.maybeNull(types.boolean),
  queryingFasting: types.maybeNull(types.boolean),
  syncingFasting: types.maybeNull(types.boolean),
  syncedFasting: types.maybeNull(types.boolean),
  queryingFeedingTrayControl: types.maybeNull(types.boolean),
  syncingFeedingTrayControl: types.maybeNull(types.boolean),
  syncedFeedingTrayControl: types.maybeNull(types.boolean),
  queryingSampling: types.maybeNull(types.boolean),
  syncingSampling: types.maybeNull(types.boolean),
  syncedSampling: types.maybeNull(types.boolean),
  queryingTreatment: types.maybeNull(types.boolean),
  syncingTreatment: types.maybeNull(types.boolean),
  syncedTreatment: types.maybeNull(types.boolean),
  queryingHarvest: types.maybeNull(types.boolean),
  syncingHarvest: types.maybeNull(types.boolean),
  syncedHarvest: types.maybeNull(types.boolean),
  queryingMortality: types.maybeNull(types.boolean),
  syncingMortality: types.maybeNull(types.boolean),
  syncedMortality: types.maybeNull(types.boolean),
  queryingChemicalMultiMeasurement: types.maybeNull(types.boolean),
  syncingChemicalMultiMeasurement: types.maybeNull(types.boolean),
  syncedChemicalMultiMeasurement: types.maybeNull(types.boolean),
  queryingPlanktonMultiMeasurement: types.maybeNull(types.boolean),
  syncingPlanktonMultiMeasurement: types.maybeNull(types.boolean),
  syncedPlanktonMultiMeasurement: types.maybeNull(types.boolean),
  queryingMicrobiologyMultiMeasurement: types.maybeNull(types.boolean),
  syncingMicrobiologyMultiMeasurement: types.maybeNull(types.boolean),
  syncedMicrobiologyMultiMeasurement: types.maybeNull(types.boolean),
  queryingCycleDisease: types.maybeNull(types.boolean),
  syncingCycleDisease: types.maybeNull(types.boolean),
  syncedCycleDisease: types.maybeNull(types.boolean),
  queryingCyclePrediction: types.maybeNull(types.boolean),
  syncingCyclePrediction: types.maybeNull(types.boolean),
  syncedCyclePrediction: types.maybeNull(types.boolean),
  queryingCycleActual: types.maybeNull(types.boolean),
  syncingCycleActual: types.maybeNull(types.boolean),
  syncedCycleActual: types.maybeNull(types.boolean),
  queryingCycleToDo: types.maybeNull(types.boolean),
  syncingCycleToDo: types.maybeNull(types.boolean),
  syncedCycleToDo: types.maybeNull(types.boolean)
}

/**
 * Model description here for TypeScript hints.
 */
export const CycleStoreModel = types
  .model("CycleStore")
  .props(CycleStoreProps)
  .views((self) => ({
    get waterQualityMultiMeasurementsPerDate() {
      return _.map(_.groupBy(self.waterQualityMultiMeasurements, 'measured_date'), (value, key) => ({
        measured_date: key,
        multi_measurements: value,
        age: value[0].age
      }))
    },
    get feedsPerDate() {
      return _.map(_.groupBy(self.feeds, (feed) => feed.feed_at || moment.utc(feed.logged_at).local().format('YYYY-MM-DD')), (value, key) => ({
        feed_at: key,
        feeds: value,
        age: value[0].age
      }))
    },
    get feedingTrayControlsPerDatePerTime() {
      return _.map(_.groupBy(self.feedingTrayControls, (feedingTrayControl) => moment.utc(feedingTrayControl.feed_logged_at).local().format('YYYY-MM-DD')), (value, key) => ({
        feed_at: key,
        feeding_tray_controls: _.map(_.groupBy(value, (v) => v.logged_at), (v, key) => ({
          ids: v.map((f) => f.id),
          logged_at: key,
          feeding_tray_controls: v,
          age: v[0].age,
          synced: _.reduce(v, (synced, f) => synced && !!f.synced_at, true)
        })),
        age: value[0].age
      }))
    },
    get treatmentsPerDate() {
      return _.map(_.groupBy(self.treatments, (t) => t.treated_at), (value, key) => ({
        treated_at: key,
        treatments: value,
        age: value[0].age
      }))
    },
    get loadingWaterQualityMultiMeasurement() {
      return self.queryingWaterQualityMultiMeasurement || self.syncingWaterQualityMultiMeasurement;
    },
    get loadingFeed() {
      return self.queryingFeed || self.syncingFeed
    },
    get loadingFeedingTrayControl() {
      return self.queryingFeedingTrayControl || self.syncingFeedingTrayControl
    },
    get loadingSampling() {
      return self.queryingSampling || self.syncingSampling
    },
    get loadingTreatment() {
      return self.queryingTreatment || self.syncingTreatment
    },
    get loadingHarvest() {
      return self.queryingHarvest || self.syncingHarvest
    },
    get loadingMortality() {
      return self.queryingMortality || self.syncingMortality
    },
    get loadingChemicalMultiMeasurement() {
      return self.queryingChemicalMultiMeasurement || self.syncingChemicalMultiMeasurement;
    },
    get loadingPlanktonMultiMeasurement() {
      return self.queryingPlanktonMultiMeasurement || self.syncingPlanktonMultiMeasurement;
    },
    get loadingMicrobiologyMultiMeasurement() {
      return self.queryingMicrobiologyMultiMeasurement || self.syncingMicrobiologyMultiMeasurement;
    },
    get loadingCycleDisease() {
      return self.queryingCycleDisease || self.syncingCycleDisease
    },
    get loadingCyclePrediction() {
      return self.queryingCyclePrediction || self.syncingCyclePrediction
    },
    get loadingCycleActual() {
      return self.queryingCycleActual || self.syncingCycleActual
    },
    get loadingCyclePredictionCycleActual() {
      return this.loadingCyclePrediction || this.loadingCycleActual
    },
    get synced() {
      return (
        self.syncedWaterQualityMultiMeasurement
        && self.syncedFeed
        && self.syncedFeedingTrayControl
        && self.syncedSampling
        && self.syncedTreatment
        && self.syncedHarvest
        && self.syncedMortality
        && self.syncedChemicalMultiMeasurement
        && self.syncedPlanktonMultiMeasurement
        && self.syncedMicrobiologyMultiMeasurement
        && self.syncedCycleDisease
      )
    },
    get progress() {
      return 100 * (
        Number(self.syncedWaterQualityMultiMeasurement)
        + Number(self.syncedFeed)
        + Number(self.syncedFeedingTrayControl)
        + Number(self.syncedSampling)
        + Number(self.syncedTreatment)
        + Number(self.syncedHarvest)
        + Number(self.syncedMortality)
        + Number(self.syncedChemicalMultiMeasurement)
        + Number(self.syncedPlanktonMultiMeasurement)
        + Number(self.syncedMicrobiologyMultiMeasurement)
        + Number(self.syncedCycleDisease)
      ) / 11
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof CycleStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    async getWaterQualityMultiMeasurements(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingWaterQualityMultiMeasurement', true);
        MultiMeasurement.parameters = await Parameter.fetch({ parameter_category_id__eq: 1, sort: 'number' }).catch(() => [])
        const parameterIds = MultiMeasurement.parameters.map((parameter) => parameter.getKey())
        const waterQualityMultiMeasurements = await MultiMeasurement.fetch({
          pond_id__eq: self.cycle?.pond_id,
          cycle_id__in: self.cycleId,
          parameter_id__in: parameterIds.join(','),
          sort: 'measured_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        MultiMeasurement.parameters = Measurement.parameters
        this.set('waterQualityMultiMeasurements', waterQualityMultiMeasurements.map((waterQualityMultiMeasurement) => waterQualityMultiMeasurement.toArray()));
        this.set('queryingWaterQualityMultiMeasurement', false);
      }
      else {
        this.set('queryingWaterQualityMultiMeasurement', true);
        this.syncWaterQualityMultiMeasurements().then(async () => {
          await this.getWaterQualityMultiMeasurements(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedWaterQualityMultiMeasurement', true);
          this.set('queryingWaterQualityMultiMeasurement', false);
        })
      }
    },
    async syncWaterQualityMultiMeasurements() {
      if (Platform.OS === 'web') return true;

      this.set('syncingWaterQualityMultiMeasurement', true)
      const parameters = await Parameter.fetch({ parameter_category_id__eq: 1, sort: 'number' }).catch(() => [])
      const parameterIds = parameters.map((parameter) => parameter.getKey())
      Measurement.endpoint = `/ponds/${self.cycle?.pond_id}/measurements`
      const success = await Measurement.syncAll(
        { cycle_id__in: self.cycleId, parameter_id__in: parameterIds.join(',') },
        [
          ['measurements.cycle_id', [self.cycleId]],
          ['measurements.parameter_id', parameterIds]
        ], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Measurement.endpoint = `/measurements`

      this.set('syncingWaterQualityMultiMeasurement', false)
      return success
    },
    async getFeeds(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingFeed', true);
        const feeds = await Feed.fetch({
          cycle_id__in: self.cycleId,
          sort: 'logged_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('feeds', feeds.map((feed) => feed.toArray()));
        this.set('queryingFeed', false);
      }
      else {
        this.set('queryingFeed', true);
        this.syncFeeds().then(async () => {
          await this.getFeeds(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedFeed', true);
          this.set('queryingFeed', false);
        })
      }
    },
    async syncFeeds() {
      if (Platform.OS === 'web') return true;

      this.set('syncingFeed', true)
      Feed.endpoint = `/cycles/${self.cycleId}/feeds`
      const success = await Feed.syncAll(
        { cycle_id__in: self.cycleId },
        [['feeds.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Feed.endpoint = `/feeds`

      this.set('syncingFeed', false)
      return success
    },
    async getFastings(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingFasting', true);
        const fastings = await Fasting.fetch({
          cycle_id__in: self.cycleId,
          sort: 'logged_date,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('fastings', fastings.map((fasting) => fasting.toArray()));
        this.set('queryingFasting', false);
      }
      else {
        this.set('queryingFasting', true);
        this.syncFastings().then(async () => {
          await this.getFastings(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedFasting', true);
          this.set('queryingFasting', false);
        })
      }
    },
    async syncFastings() {
      if (Platform.OS === 'web') return true;

      this.set('syncingFasting', true)
      Fasting.endpoint = `/cycles/${self.cycleId}/fastings`
      const success = await Fasting.syncAll(
        { cycle_id__in: self.cycleId },
        [['fastings.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Fasting.endpoint = `/fastings`

      this.set('syncingFasting', false)
      return success
    },
    async getFeedingTrayControls(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingFeedingTrayControl', true);
        const feedingTrayControls = await FeedingTrayControl.fetch({
          cycle_id__in: self.cycleId,
          sort: 'logged_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('feedingTrayControls', feedingTrayControls.map((feedingTrayControl) => feedingTrayControl.toArray()));
        this.set('queryingFeedingTrayControl', false);
      }
      else {
        this.set('queryingFeedingTrayControl', true);
        this.syncFeedingTrayControls().then(async () => {
          await this.getFeedingTrayControls(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedFeedingTrayControl', true);
          this.set('queryingFeedingTrayControl', false);
        })
      }
    },
    async syncFeedingTrayControls() {
      if (Platform.OS === 'web') return true;

      this.set('syncingFeedingTrayControl', true)
      const success = await FeedingTrayControl.syncAll(
        { cycle_id__in: self.cycleId },
        [['feeding_tray_controls.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )

      this.set('syncingFeedingTrayControl', false)
      return success
    },
    async getSamplings(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingSampling', true);
        const samplings = await Sampling.fetch({
          cycle_id__in: self.cycleId,
          sort: 'sampled_at,desc|created_at,desc'
        }).then((samplings) => File.fetch({
          fileable_type__eq: 'App\\Sampling',
          fileable_id__in: samplings.map((c: Sampling) => c.getKey()).join(','),
          sort: 'created_at'
        }).then((files) => {
          const filesGroupBySamplingId = _.groupBy(files, (f: File) => f.getAttribute('fileable_id'))
          return samplings.map((c: Sampling) => c.setRelation('files', filesGroupBySamplingId[c.getKey()] || []))
        })).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('samplings', samplings.map((sampling) => sampling.toArray()));
        this.set('queryingSampling', false);
      }
      else {
        this.set('queryingSampling', true);
        this.syncSamplings().then(async () => {
          await this.getSamplings(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedSampling', true);
          this.set('queryingSampling', false);
        })
      }
    },
    async syncSamplings() {
      if (Platform.OS === 'web') return true;

      this.set('syncingSampling', true)
      Sampling.endpoint = `/cycles/${self.cycleId}/samplings`
      const success = await Sampling.syncAll(
        { cycle_id__in: self.cycleId },
        [['samplings.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      ).then(async (success) => {
        if (!success) return success;
        const samplings = await Sampling.fetch({
          cycle_id__in: self.cycleId,
          sort: 'sampled_at,desc|created_at,desc'
        })
        if (!samplings.length) return success
        const samplingIds = samplings.map((c: Sampling) => c.getKey());
        return File.syncAll(
          {
            fileable_type__eq: 'App\\Sampling',
            fileable_id__in: samplingIds.join(','),
          },
          [
            ['files.fileable_type', ['App\\Sampling']],
            ['files.fileable_id', samplingIds]
          ], true, undefined, (e) => {
            if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
          }
        )
      })
      Sampling.endpoint = `/samplings`

      this.set('syncingSampling', false)
      return success
    },
    async getTreatments(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingTreatment', true);
        const treatments = await Treatment.fetch({
          cycle_id__in: self.cycleId,
          sort: 'treated_at,desc|created_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('treatments', treatments.map((treatment) => treatment.toArray()));
        this.set('queryingTreatment', false);
      }
      else {
        this.set('queryingTreatment', true);
        this.syncTreatments().then(async () => {
          await this.getTreatments(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedTreatment', true);
          this.set('queryingTreatment', false);
        })
      }
    },
    async syncTreatments() {
      if (Platform.OS === 'web') return true;

      this.set('syncingTreatment', true)
      Treatment.endpoint = `/ponds/${self.cycle?.pond_id}/treatments`
      const success = await Treatment.syncAll(
        { cycle_id__in: self.cycleId },
        [[new Treatment().qualifyColumn('cycle_id'), [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Treatment.endpoint = `/treatments`

      this.set('syncingTreatment', false)
      return success
    },
    async getHarvests(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingHarvest', true);
        const harvests = await Harvest.fetch({
          cycle_id__in: self.cycleId,
          sort: 'harvested_at,desc|created_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('harvests', harvests.map((harvest) => harvest.toArray()));
        this.set('queryingHarvest', false);
      }
      else {
        this.set('queryingHarvest', true);
        this.syncHarvests().then(async () => {
          await this.getHarvests(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedHarvest', true);
          this.set('queryingHarvest', false);
        })
      }
    },
    async syncHarvests() {
      if (Platform.OS === 'web') return true;

      this.set('syncingHarvest', true)
      Harvest.endpoint = `/cycles/${self.cycleId}/harvests`
      const success = await Harvest.syncAll(
        { cycle_id__in: self.cycleId },
        [['harvests.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Harvest.endpoint = `/harvests`

      this.set('syncingHarvest', false)
      return success
    },
    async getMortalities(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingMortality', true);
        const mortalities = await Mortality.fetch({
          cycle_id__in: self.cycleId,
          sort: 'recorded_at,desc|created_at,desc'
        }).then((mortalities) => File.fetch({
          fileable_type__eq: 'App\\Mortality',
          fileable_id__in: mortalities.map((c: Mortality) => c.getKey()).join(','),
          sort: 'created_at'
        }).then((files) => {
          const filesGroupByMortalityId = _.groupBy(files, (f: File) => f.getAttribute('fileable_id'))
          return mortalities.map((c: Mortality) => c.setRelation('files', filesGroupByMortalityId[c.getKey()] || []))
        })).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('mortalities', mortalities.map((mortality) => mortality.toArray()));
        this.set('queryingMortality', false);
      }
      else {
        this.set('queryingMortality', true);
        this.syncMortalities().then(async () => {
          await this.getMortalities(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedMortality', true);
          this.set('queryingMortality', false);
        })
      }
    },
    async syncMortalities() {
      if (Platform.OS === 'web') return true;

      this.set('syncingMortality', true)
      Mortality.endpoint = `/cycles/${self.cycleId}/mortalities`
      const success = await Mortality.syncAll(
        { cycle_id__in: self.cycleId },
        [['mortalities.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      ).then(async (success) => {
        if (!success) return success;
        const mortalities = await Mortality.fetch({
          cycle_id__in: self.cycleId,
          sort: 'recorded_at,desc|created_at,desc'
        })
        if (!mortalities.length) return success
        const mortalityIds = mortalities.map((c: Mortality) => c.getKey());
        return File.syncAll(
          {
            fileable_type__eq: 'App\\Mortality',
            fileable_id__in: mortalityIds.join(','),
          },
          [
            ['files.fileable_type', ['App\\Mortality']],
            ['files.fileable_id', mortalityIds]
          ], true, undefined, (e) => {
            if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
          }
        )
      })
      Mortality.endpoint = `/mortalities`

      this.set('syncingMortality', false)
      return success
    },
    async getChemicalMultiMeasurements(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingChemicalMultiMeasurement', true);
        MultiMeasurement.parameters = await Parameter.fetch({ parameter_category_id__eq: 2, sort: 'number' }).catch(() => [])
        const parameterIds = MultiMeasurement.parameters.map((parameter) => parameter.getKey())
        const chemicalMultiMeasurements = await MultiMeasurement.fetch({
          cycle_id__in: self.cycleId,
          parameter_id__in: parameterIds.join(','),
          sort: 'measured_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        MultiMeasurement.parameters = Measurement.parameters
        this.set('chemicalMultiMeasurements', chemicalMultiMeasurements.map((chemicalMultiMeasurement) => chemicalMultiMeasurement.toArray()));
        this.set('queryingChemicalMultiMeasurement', false);
      }
      else {
        this.set('queryingChemicalMultiMeasurement', true);
        this.syncChemicalMultiMeasurements().then(async () => {
          await this.getChemicalMultiMeasurements(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedChemicalMultiMeasurement', true);
          this.set('queryingChemicalMultiMeasurement', false);
        })
      }
    },
    async syncChemicalMultiMeasurements() {
      if (Platform.OS === 'web') return true;

      this.set('syncingChemicalMultiMeasurement', true)
      const parameters = await Parameter.fetch({ parameter_category_id__eq: 2, sort: 'number' }).catch(() => [])
      const parameterIds = parameters.map((parameter) => parameter.getKey())
      Measurement.endpoint = `/ponds/${self.cycle?.pond_id}/measurements`
      const success = await Measurement.syncAll(
        { cycle_id__in: self.cycleId, parameter_id__in: parameterIds.join(',') },
        [
          ['measurements.cycle_id', [self.cycleId]],
          ['measurements.parameter_id', parameterIds]
        ], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Measurement.endpoint = `/measurements`

      this.set('syncingChemicalMultiMeasurement', false)
      return success
    },
    async getPlanktonMultiMeasurements(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingPlanktonMultiMeasurement', true);
        MultiMeasurement.parameters = await Parameter.fetch({ parameter_category_id__eq: 3, sort: 'number' }).catch(() => [])
        const parameterIds = MultiMeasurement.parameters.map((parameter) => parameter.getKey())
        const planktonMultiMeasurements = await MultiMeasurement.fetch({
          cycle_id__in: self.cycleId,
          parameter_id__in: parameterIds.join(','),
          sort: 'measured_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        MultiMeasurement.parameters = Measurement.parameters
        this.set('planktonMultiMeasurements', planktonMultiMeasurements.map((planktonMultiMeasurement) => planktonMultiMeasurement.toArray()));
        this.set('queryingPlanktonMultiMeasurement', false);
      }
      else {
        this.set('queryingPlanktonMultiMeasurement', true);
        this.syncPlanktonMultiMeasurements().then(async () => {
          await this.getPlanktonMultiMeasurements(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedPlanktonMultiMeasurement', true);
          this.set('queryingPlanktonMultiMeasurement', false);
        })
      }
    },
    async syncPlanktonMultiMeasurements() {
      if (Platform.OS === 'web') return true;

      this.set('syncingPlanktonMultiMeasurement', true)
      const parameters = await Parameter.fetch({ parameter_category_id__eq: 3, sort: 'number' }).catch(() => [])
      const parameterIds = parameters.map((parameter) => parameter.getKey())
      Measurement.endpoint = `/ponds/${self.cycle?.pond_id}/measurements`
      const success = await Measurement.syncAll(
        { cycle_id__in: self.cycleId, parameter_id__in: parameterIds.join(',') },
        [
          ['measurements.cycle_id', [self.cycleId]],
          ['measurements.parameter_id', parameterIds]
        ], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Measurement.endpoint = `/measurements`

      this.set('syncingPlanktonMultiMeasurement', false)
      return success
    },
    async getMicrobiologyMultiMeasurements(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingMicrobiologyMultiMeasurement', true);
        MultiMeasurement.parameters = await Parameter.fetch({ parameter_category_id__eq: 4, sort: 'number' }).catch(() => [])
        const parameterIds = MultiMeasurement.parameters.map((parameter) => parameter.getKey())
        const microbiologyMultiMeasurements = await MultiMeasurement.fetch({
          cycle_id__in: self.cycleId,
          parameter_id__in: parameterIds.join(','),
          sort: 'measured_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        MultiMeasurement.parameters = Measurement.parameters
        this.set('microbiologyMultiMeasurements', microbiologyMultiMeasurements.map((microbiologyMultiMeasurement) => microbiologyMultiMeasurement.toArray()));
        this.set('queryingMicrobiologyMultiMeasurement', false);
      }
      else {
        this.set('queryingMicrobiologyMultiMeasurement', true);
        this.syncMicrobiologyMultiMeasurements().then(async () => {
          await this.getMicrobiologyMultiMeasurements(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedMicrobiologyMultiMeasurement', true);
          this.set('queryingMicrobiologyMultiMeasurement', false);
        })
      }
    },
    async syncMicrobiologyMultiMeasurements() {
      if (Platform.OS === 'web') return true;

      this.set('syncingMicrobiologyMultiMeasurement', true)
      const parameters = await Parameter.fetch({ parameter_category_id__eq: 4, sort: 'number' }).catch(() => [])
      const parameterIds = parameters.map((parameter) => parameter.getKey())
      Measurement.endpoint = `/ponds/${self.cycle?.pond_id}/measurements`
      const success = await Measurement.syncAll(
        { cycle_id__in: self.cycleId, parameter_id__in: parameterIds.join(',') },
        [
          ['measurements.cycle_id', [self.cycleId]],
          ['measurements.parameter_id', parameterIds]
        ], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      Measurement.endpoint = `/measurements`

      this.set('syncingMicrobiologyMultiMeasurement', false)
      return success
    },
    async getCycleDiseases(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingCycleDisease', true);
        const cycleDiseases = await CycleDisease.fetch({
          cycle_id__in: self.cycleId,
          sort: 'logged_at,desc|created_at,desc'
        }).then((cycleDiseases) => File.fetch({
          fileable_type__eq: 'App\\CycleDisease',
          fileable_id__in: cycleDiseases.map((c: CycleDisease) => c.getKey()).join(','),
          sort: 'created_at'
        }).then((files) => {
          const filesGroupByCycleDiseaseId = _.groupBy(files, (f: File) => f.getAttribute('fileable_id'))
          return cycleDiseases.map((c: CycleDisease) => c.setRelation('files', filesGroupByCycleDiseaseId[c.getKey()] || []))
        })).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('cycleDiseases', cycleDiseases.map((cycleDisease) => cycleDisease.toArray()));
        this.set('queryingCycleDisease', false);
      }
      else {
        this.set('queryingCycleDisease', true);
        this.syncCycleDiseases().then(async () => {
          await this.getCycleDiseases(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedCycleDisease', true);
          this.set('queryingCycleDisease', false);
        })
      }
    },
    async syncCycleDiseases() {
      if (Platform.OS === 'web') return true;

      this.set('syncingCycleDisease', true)
      CycleDisease.endpoint = `/cycles/${self.cycleId}/cycle_diseases`
      const success = await CycleDisease.syncAll(
        { cycle_id__in: self.cycleId },
        [['cycle_diseases.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      ).then(async (success) => {
        if (!success) return success;
        const cycleDiseases = await CycleDisease.fetch({
          cycle_id__in: self.cycleId,
          sort: 'logged_at,desc|created_at,desc'
        })
        if (!cycleDiseases.length) return success
        const cycleDiseaseIds = cycleDiseases.map((c: CycleDisease) => c.getKey());
        return File.syncAll(
          {
            fileable_type__eq: 'App\\CycleDisease',
            fileable_id__in: cycleDiseaseIds.join(','),
          },
          [
            ['files.fileable_type', ['App\\CycleDisease']],
            ['files.fileable_id', cycleDiseaseIds]
          ], true, undefined, (e) => {
            if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
          }
        )
      })
      CycleDisease.endpoint = `/cycle_diseases`

      this.set('syncingCycleDisease', false)
      return success
    },
    async getCyclePredictions(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingCyclePrediction', true);
        const cyclePredictions = await CyclePrediction.fetch({
          cycle_id__in: self.cycleId,
          sort: 'age,desc',
          generate_by_cycle_id: self.cycleId
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('cyclePredictions', cyclePredictions.map((cyclePrediction) => cyclePrediction.toArray()));
        this.set('queryingCyclePrediction', false);
      }
      else {
        this.set('queryingCyclePrediction', true);
        this.syncCyclePredictions().then(async () => {
          await this.getCyclePredictions(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedCyclePrediction', true);
          this.set('queryingCyclePrediction', false);
        })
      }
    },
    async syncCyclePredictions() {
      if (Platform.OS === 'web') return true;

      this.set('syncingCyclePrediction', true)
      CyclePrediction.endpoint = `/cycles/${self.cycleId}/cycle_predictions`
      const success = await CyclePrediction.syncAll(
        { cycle_id__in: self.cycleId },
        [['cycle_predictions.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      CyclePrediction.endpoint = `/cycle_predictions`

      this.set('syncingCyclePrediction', false)
      return success
    },
    async getCycleActuals(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingCycleActual', true);
        const cycleActuals = await CycleActual.fetch({
          cycle_id__in: self.cycleId,
          sort: 'age,desc',
          generate_by_cycle_id: self.cycleId
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('cycleActuals', cycleActuals.map((cycleActual) => cycleActual.toArray()));
        this.set('queryingCycleActual', false);
      }
      else {
        this.set('queryingCycleActual', true);
        this.syncCycleActuals().then(async () => {
          await this.getCycleActuals(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedCycleActual', true);
          this.set('queryingCycleActual', false);
        })
      }
    },
    async syncCycleActuals() {
      if (Platform.OS === 'web') return true;

      this.set('syncingCycleActual', true)
      CycleActual.endpoint = `/cycles/${self.cycleId}/cycle_actuals`
      const success = await CycleActual.syncAll(
        { cycle_id__in: self.cycleId },
        [['cycle_actuals.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )
      CycleActual.endpoint = `/cycle_actuals`

      this.set('syncingCycleActual', false)
      return success
    },
    async getCycleToDos(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingCycleToDo', true);
        const cycleToDos = await CycleToDo.fetch({
          cycle_id__in: self.cycleId,
          sort: 'logged_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('cycleToDos', cycleToDos.map((cycleToDo) => cycleToDo.toArray()));
        this.set('queryingCycleToDo', false);
      }
      else {
        this.set('queryingCycleToDo', true);
        this.syncCycleToDos().then(async () => {
          await this.getCycleToDos(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedCycleToDo', true);
          this.set('queryingCycleToDo', false);
        })
      }
    },
    async syncCycleToDos() {
      if (Platform.OS === 'web') return true;

      this.set('syncingCycleToDo', true)
      const success = await CycleToDo.syncAll(
        { cycle_id__in: self.cycleId },
        [['cycle_to_dos.cycle_id', [self.cycleId]]], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )

      this.set('syncingCycleToDo', false)
      return success
    },
    init() {
      this.set('initiating', false);
      this.getWaterQualityMultiMeasurements().catch()
    },
    initAll() {
      this.set('initiating', true)
      this.set('syncingLabel', 'cycles')
      return Promise.all([
        new Promise<void>(resolve => {
          this.getWaterQualityMultiMeasurements(true, () => {
            this.set('syncingLabel', 'waterQualityMultiMeasurements')
            this.getChemicalMultiMeasurements(true, () => {
              this.set('syncingLabel', 'chemicalMultiMeasurements')
              this.getPlanktonMultiMeasurements(true, () => {
                this.set('syncingLabel', 'planktonMultiMeasurements')
                this.getMicrobiologyMultiMeasurements(true, () => {
                  this.set('syncingLabel', 'planktonMultiMeasurements')
                  resolve()
                }).catch()
              }).catch()
            }).catch()
          }).catch();
          this.set('queryingChemicalMultiMeasurement', true);
          this.set('queryingPlanktonMultiMeasurement', true);
          this.set('queryingMicrobiologyMultiMeasurement', true);
        }),
        new Promise<void>(resolve => {
          this.getFeeds(true, () => {
            this.set('syncingLabel', 'feeds')
            this.getFeedingTrayControls(true, () => {
              this.set('syncingLabel', 'feedingTrayControls')
              resolve()
            }).catch()
          }).catch();
          this.set('queryingFeedingTrayControl', true);
        }),
        new Promise<void>(resolve => {
          this.getSamplings(true, () => {
            this.set('syncingLabel', 'samplings')
            resolve()
          }).catch()
        }),
        new Promise<void>(resolve => {
          this.getTreatments(true, () => {
            this.set('syncingLabel', 'treatments')
            resolve()
          }).catch()
        }),
        new Promise<void>(resolve => {
          this.getHarvests(true, () => {
            this.set('syncingLabel', 'harvests')
            resolve()
          }).catch()
        }),
        new Promise<void>(resolve => {
          this.getMortalities(true, () => {
            this.set('syncingLabel', 'mortalities')
            resolve()
          }).catch()
        }),
        new Promise<void>(resolve => {
          this.getCycleDiseases(true, () => {
            this.set('syncingLabel', 'cycleDiseases')
            resolve()
          }).catch()
        }),
      ]).finally(() => {
        this.set('syncingLabel', null)
        this.set('initiating', false)
      });
    },
    initAllSequential() {
      this.set('initiating', true)
      let promise = Promise.resolve(null);
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'waterQualityMultiMeasurements')
        this.getWaterQualityMultiMeasurements(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'feeds')
        this.getFeeds(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'feedingTrayControls')
        this.getFeedingTrayControls(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'samplings')
        this.getSamplings(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'treatments')
        this.getTreatments(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'harvests')
        this.getHarvests(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'mortalities')
        this.getMortalities(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'chemicalMultiMeasurements')
        this.getChemicalMultiMeasurements(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'planktonMultiMeasurements')
        this.getPlanktonMultiMeasurements(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'microbiologyMultiMeasurements')
        this.getMicrobiologyMultiMeasurements(true, resolve).catch()
      }))
      promise = promise.then(() => new Promise(resolve => {
        this.set('syncingLabel', 'cycleDiseases')
        this.getCycleDiseases(true, resolve).catch()
      }))
      return promise
        .finally(() => {
          this.set('syncingLabel', null)
          this.set('initiating', false)
        });
    },
    async initAllSyncSequential() {
      this.set('initiating', true)
      this.set('syncingLabel', 'waterQualityMultiMeasurements')
      await this.syncWaterQualityMultiMeasurements().catch()
      this.set('syncedWaterQualityMultiMeasurement', true)
      this.set('syncingLabel', 'feeds')
      await this.syncFeeds().catch()
      this.set('syncedFeed', true)
      this.set('syncingLabel', 'feedingTrayControls')
      await this.syncFeedingTrayControls().catch()
      this.set('syncedFeedingTrayControl', true)
      this.set('syncingLabel', 'samplings')
      await this.syncSamplings().catch()
      this.set('syncedSampling', true)
      this.set('syncingLabel', 'treatments')
      await this.syncTreatments().catch()
      this.set('syncedTreatment', true)
      this.set('syncingLabel', 'harvests')
      await this.syncHarvests().catch()
      this.set('syncedHarvest', true)
      this.set('syncingLabel', 'mortalities')
      await this.syncMortalities().catch()
      this.set('syncedMortality', true)
      this.set('syncingLabel', 'chemicalMultiMeasurements')
      await this.syncChemicalMultiMeasurements().catch()
      this.set('syncedChemicalMultiMeasurement', true)
      this.set('syncingLabel', 'planktonMultiMeasurements')
      await this.syncPlanktonMultiMeasurements().catch()
      this.set('syncedPlanktonMultiMeasurement', true)
      this.set('syncingLabel', 'microbiologyMultiMeasurements')
      await this.syncMicrobiologyMultiMeasurements().catch()
      this.set('syncedMicrobiologyMultiMeasurement', true)
      this.set('syncingLabel', 'cycleDiseases')
      await this.syncCycleDiseases().catch()
      this.set('syncedCycleDisease', true)
      this.set('syncingLabel', null)
      this.set('initiating', false)
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type CycleStoreType = Instance<typeof CycleStoreModel>
export interface CycleStore extends CycleStoreType {}
type CycleStoreSnapshotType = SnapshotOut<typeof CycleStoreModel>
export interface CycleStoreSnapshot extends CycleStoreSnapshotType {}
export const createCycleStoreDefaultModel = () => types.optional(CycleStoreModel, {})
